import type { UseQueryReturnType } from '@tanstack/vue-query';
import { httpGet } from '@/api/http';
import { V2_USERS_AVAILABILITY } from '@/constants/endpoint';
import type { AxiosError } from 'axios';
import type { UserAvailabilityDTO } from '@/data/UserAvailability';
import { useAuthenticatedQuery } from '@/utils/query';

export const USERS_AVAILABILITY_QUERY_KEY = 'usersAvailability';

type UsersAvailabilityApiData = Record<string, UserAvailabilityDTO>;

export const useUsersAvailabilityQuery = {
  queryKey: [USERS_AVAILABILITY_QUERY_KEY],
  queryFn: () => httpGet<UsersAvailabilityApiData>(V2_USERS_AVAILABILITY),
  refetchInterval: 5_000,
  refetchOnMount: false,
};

export const useUsersAvailability = (): UseQueryReturnType<UsersAvailabilityApiData, AxiosError<unknown, any>> => {
  return useAuthenticatedQuery(useUsersAvailabilityQuery);
};
